import { ShieldCheck, CheckCircle2, XCircle, Wallet, ArrowDownToLine } from "lucide-react";
import { PageHeader } from "@/screens/_shared";

const RefundPolicy = () => (
    <div className="screen" data-testid="refund-policy-screen">
        <PageHeader title="Refund Policy" />
        <div className="flex-1 overflow-y-auto no-scrollbar px-5 py-5 space-y-5">
            <div
                className="rounded-3xl p-5 text-primary-foreground shadow-card"
                style={{ background: "linear-gradient(135deg, hsl(var(--primary)) 0%, hsl(var(--primary) / 0.72) 100%)" }}
            >
                <ShieldCheck size={24} strokeWidth={2.4} />
                <h2 className="mt-3 font-display text-[18px] font-semibold leading-tight">
                    Neyra guarantees refunds when an event is cancelled or doesn't take place.
                </h2>
                <p className="mt-1.5 text-[12.5px] text-white/85">
                    Your money is held in escrow until the event happens.
                </p>
            </div>

            <Section
                icon={CheckCircle2}
                tone="ok"
                title="When you'll get a refund"
                items={[
                    "The event is cancelled by the host.",
                    "The event does not take place on the scheduled date.",
                    "The host is unreachable on the day of the event.",
                ]}
            />

            <Section
                icon={XCircle}
                tone="warn"
                title="Non-refundable events"
                items={[
                    "If the host marks the event as non-refundable, attendee-initiated cancellations are not refunded.",
                    "However — if a non-refundable event still gets cancelled or fails to take place, Neyra will refund you regardless.",
                ]}
            />

            <Section
                icon={Wallet}
                tone="ok"
                title="How refunds are paid"
                items={[
                    "Refunds are credited to your Neyra Wallet (Available balance).",
                    "Funds appear within minutes of the refund being approved.",
                    "You can withdraw refunded funds to your bank at any time.",
                ]}
            />

            <Section
                icon={ArrowDownToLine}
                tone="ok"
                title="How to request a refund"
                items={[
                    "Open the cancelled event and tap \u201CRequest refund\u201D.",
                    "Or open Wallet \u2192 Transactions, find the ticket purchase, and tap \u201CRequest refund\u201D.",
                    "Most refunds are auto-approved. Disputed cases are reviewed within 24 hours.",
                ]}
            />

            <p className="text-[11.5px] text-muted-foreground text-center">
                This policy applies to paid event tickets. Service bookings follow Neyra's escrow rules.
            </p>
        </div>
    </div>
);

const Section = ({ icon: Icon, title, items, tone }) => {
    const colors = tone === "warn"
        ? "border-amber-500/25 bg-amber-500/5 text-amber-700 dark:text-amber-300"
        : "border-border bg-card";
    return (
        <section className={`rounded-2xl border ${colors} p-4`}>
            <h3 className="font-display text-[14.5px] font-semibold inline-flex items-center gap-2">
                <Icon size={15} className={tone === "warn" ? "text-amber-600 dark:text-amber-300" : "text-primary"} />
                {title}
            </h3>
            <ul className="mt-2 space-y-1.5 text-[13px] leading-relaxed text-foreground/85">
                {items.map((it, i) => <li key={i} className="flex gap-2"><span className="text-primary mt-0.5">•</span><span>{it}</span></li>)}
            </ul>
        </section>
    );
};

export default RefundPolicy;
